module.exports = __webpack_public_path__ + "static/media/webmain.dca8a4a4.png";